<template>
  <v-btn-toggle
    class="v-btn--contained"
    v-model="cv"
    rounded
    mandatory
    borderless
    @change="selectCv"
  >
    <v-btn
      v-for="(item, index) in filterOptions"
      :key="index"
      :disabled="filterDisabled"
      class="font-weight-normal"
      :class="{ 'no-cv-btn-disabled': filterDisabled }"
    >
      {{ item.NameInHebrew }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
import FilterBaseVue from './mixins/FilterBase.vue';
import gtm from '@/lib/gtm';

export default {
  mixins: [FilterBaseVue],
  props: {
    selectedCv: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      cv: this.selectedCv.length ? this.selectedCv[0] : 0,
    };
  },
  methods: {
    selectCv() {
      this.selections = this.cv === 1 ? [this.cv] : [];
      const payload = {
        type: this.filterData.QueryParamName,
        selections: this.selections,
      };
      if (this.cv === 1) {
        gtm({
          category: 'הקלקה על משרות ללא קו"ח ',
          action: 'חיפוש',
          event: 'משרות_ללא_קוח',
        });

        gtm({
          event_name: 'הקלקה על משרות ללא קו"ח ',
          place_click: 'חיפוש',
          event: 'משרות_ללא_קוח_GA4',
        });
      }

      this.$emit('submitFilter', payload);
    },
  },
  watch: {
    selectedCv(currentCv) {
      this.cv = currentCv.length ? currentCv[0] : 0;
    },
  },
};
</script>

<style scoped lang="scss">
.v-btn--active:before,
.v-btn:hover:before,
.v-btn:active:before,
.v-btn:focus:before {
  background-color: $primary !important;
  opacity: 1 !important;
}
.no-cv-btn-disabled:before {
  background-color: rgba(0, 0, 0, 0.12) !important;
}
.v-btn--active {
  color: #fff !important;
}
.v-btn {
  background-color: #fff !important;
  opacity: 1 !important;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  background: none;
  height: 36px;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 36px;
  font-size: 16px;
  min-width: 75px;
  font-weight:normal
}
.v-item-group {
  margin: 0 0 0 8px;
}
</style>